import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { portsApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'


/**
 * Hook for fetching paginated ports list
 * Automatically refetches when URL params change
 */
export function usePorts() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.ports.list(orgId, params),
    queryFn: () => portsApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching port filter options
 * Cached for 15 minutes as these change less frequently
 */
export function usePortFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.ports.filterOptions(orgId),
    queryFn: () => portsApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}
